import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import React, { memo, useContext, useRef, useMemo } from 'react';
import _Box from '../../components/Box/index.js';
import { transparentize } from 'polished';
import useOutsideClick from '../../hooks/useOutsideClick.js';
import { DropdownContext } from './DropdownContext.js';
import useRefMultiMap, { ArrayListMultimap } from '../../hooks/useRefMultiMap.js';
import DropdownMenuItem from './_DropdownMenuItem.js';

var _templateObject, _templateObject2;
var StyledList = styled('ul')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  list-style: none;\n  margin-top: 0;\n"])));
var StyledBox = styled(_Box)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  box-shadow: ", ";\n  padding: 0;\n  position: absolute;\n  min-width: 320px;\n  margin-top: 0.5rem;\n  right: ", ";\n  visibility: ", ";\n  z-index: 1;\n"])), function (_ref) {
  var theme = _ref.theme;
  return "0 2px 3px ".concat(transparentize(0.8, theme.palette.black));
}, function (_ref2) {
  var isPinnedRight = _ref2.isPinnedRight;
  return isPinnedRight ? '0' : null;
}, function (_ref3) {
  var isOpen = _ref3.isOpen;
  return !isOpen ? 'hidden' : null;
});
var updateElements = function updateElements(dropdownItems, multimapContext, firstSubMenuItem) {
  var newDropdownElements = [];
  var newMultimap = dropdownItems.reduce(function (acc, curr, index) {
    var itemRef = index === 0 ? firstSubMenuItem : /*#__PURE__*/React.createRef();
    var handleFocus = function handleFocus() {
      multimapContext.setCurrIndex(index);
    };
    newDropdownElements.push(/*#__PURE__*/React.createElement(DropdownMenuItem, {
      ref: itemRef,
      key: curr.text,
      handleFocus: handleFocus,
      isFirst: index === 0,
      isLast: index === dropdownItems.length - 1,
      item: curr,
      navigateToNextSibling: multimapContext.navigateToNextSibling,
      navigateToPreviousSibling: multimapContext.navigateToPreviousSibling
    }));
    acc.put(itemRef, new ArrayListMultimap());
    return acc;
  }, new ArrayListMultimap());
  multimapContext.setCurrMultiMap(newMultimap);
  return newDropdownElements;
};
var handleOutsideClick = function handleOutsideClick(setIsOpen) {
  return function () {
    setIsOpen(false);
  };
};
var DropdownMenu = function DropdownMenu(_ref4) {
  var dropdownItems = _ref4.dropdownItems,
    dropdownButtonRef = _ref4.dropdownButtonRef,
    _ref4$isPinnedRight = _ref4.isPinnedRight,
    isPinnedRight = _ref4$isPinnedRight === void 0 ? false : _ref4$isPinnedRight;
  var multimapContext = useRefMultiMap();
  var _useContext = useContext(DropdownContext),
    buttonText = _useContext.buttonText,
    firstSubMenuItem = _useContext.firstSubMenuItem,
    isOpen = _useContext.isOpen,
    setIsOpen = _useContext.setIsOpen,
    theme = _useContext.theme;
  var menuRef = useRef(null);
  useOutsideClick([menuRef, dropdownButtonRef], handleOutsideClick(setIsOpen));
  var dropdownElements = useMemo(function () {
    return updateElements(dropdownItems, multimapContext, firstSubMenuItem);
  }, [dropdownItems]);
  return /*#__PURE__*/React.createElement(StyledBox, {
    color: 'grayLightest',
    theme: theme,
    isOpen: isOpen,
    isPinnedRight: isPinnedRight,
    ref: menuRef,
    "data-testid": 'dropdown-menu'
  }, /*#__PURE__*/React.createElement(StyledList, {
    "aria-label": buttonText,
    role: 'menu'
  }, dropdownElements));
};
var DropdownMenu$1 = /*#__PURE__*/memo(DropdownMenu);

export default DropdownMenu$1;
export { DropdownMenu };
